import ParameterUnitModel from '../models/ParameterUnitModel';
import BaseStore from './BaseStore';
import { computed } from 'mobx';

class ParameterUnitStore extends BaseStore {
  constructor(transportLayer) {
    super(ParameterUnitModel, transportLayer);
  }

  @computed get itemsWithLabels() {
    return this.items.map(item => ({
      ...item,
      label: `${item.name} (${item.symbol})`,
    }));
  }
}

export default ParameterUnitStore;



// WEBPACK FOOTER //
// ./src/stores/ParameterUnitStore.js